import styles from "./Welcome.module.css";
import HomeImg from "../../assets/images/Welcome.png"; // Adjust the path as necessary
import { useEffect, useState } from "react";

const Welcome = () => {
  const [dimensions, setDimensions] = useState({ height: 500, width: "100%" });
  useEffect(() => {
    const updateDimensions = () => {
      const width = window.innerWidth;
      let height;
      if (width > 1200) {
        console.log("Width is greater than 1200px");
        height = 500;
      } else if (width > 992) {
        console.log("Width is greater than 992px");
        height = 400;
      } else if (width > 768) {
        console.log("Width is greater than 768px");
        height = 350;
      } else if (width > 576) {
        console.log("Width is greater than 576px");
        height = 300;
      } else {
        console.log("Width is 576px or less");
        height = 250;
      }
      setDimensions({ height, width: "100%" });
    };
    window.addEventListener("resize", updateDimensions);
    updateDimensions();
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);
  return (
    <div
      className={styles.rpmain}
      data-testid="welcome-component"
      style={{ overflow: "hidden", margin: ".5vh" }}
    >
      <div className={styles.welcomebg} style={{ height: "500px" }}>
        <div className="col-sm-7" style={{ float: "left" }}>
          <h3 className={styles.bodywelcome}>
            Welcome to <b>DocDistro</b>
          </h3>
        </div>
        <div className="col-sm-5" style={{ float: "right" }}>
          <img
            src={HomeImg}
            style={{
              height: dimensions.height,
              width: dimensions.width,
              objectFit: "contain",
              borderRadius: "10px",             
            }}
            alt="Welcome to DocDistro"
          />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
